import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VeeValidate from 'vee-validate'
import ScrollLoader from 'vue-scroll-loader'
import VueScrollto from 'vue-scrollto'
import VModal from 'vue-js-modal'
import GlobalConstant from '../src/infrastructure/GlobalConstant'
import VueMoment from 'vue-moment'
import axios from 'axios'
import AuthService from '../src/services/auth/auth.service'
import VueTour from 'vue-tour'
import VueI18n from 'vue-i18n'
import VueSignaturePad from 'vue-signature-pad'
require('vue-tour/dist/vue-tour.css')

/* GLOBAL CONSTANT VARIABLES HERE */
/* On any vue file access using this.$variableName */
Vue.prototype.$globalConstant = GlobalConstant
Vue.prototype.$intMax = 2147483647
Vue.prototype.$notAvailableImageSrc = process.env.VUE_APP_ImageNotAvailableSrc
Vue.prototype.$notAvailableLogoSrc = process.env.VUE_APP_LogoNotAvailableSrc
Vue.prototype.$defaultStudentImageSrc = process.env.VUE_APP_DefaultStudentImageSrc
Vue.prototype.$defaultUserImageSrc = process.env.VUE_APP_DefaultUserImageSrc
Vue.prototype.$defaultLoadingImageSrc = process.env.VUE_APP_DefaultLoadingImageSrc
Vue.prototype.$Referrer = '/'
Vue.prototype.$shopShortName = getShopShortName()
/* ------------------------------- */

Vue.config.productionTip = false

// Ignore Dialogflow Messenger web components
Vue.config.ignoredElements = [/^df-/]

// Configuring i18n
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages: {}
})

function fetchJson (url) {
  return fetch(url)
    .then(r => (r.ok ? r.json() : {}))
    .catch(() => ({}))
}

Vue.use(VueSignaturePad)

async function loadLocaleMessages (lang) {
  const namespaces = [
    'common',
    'nav',
    'setup',
    'aiagent',
    'user',
    'sidebar',
    'footer',
    'layout'
  ]
  const results = await Promise.all(
    namespaces.map(ns =>
      fetchJson(process.env.VUE_APP_BASE_URL + `/locales/${lang}/${ns}.json`)
    )
  )
  const messages = {}
  namespaces.forEach((ns, idx) => {
    if (results[idx] && Object.keys(results[idx]).length) {
      messages[ns] = results[idx]
    }
  })
  return messages
}

const config = {
  fieldsBagName: 'fieldBags'
} // used to avoid 'fields'prop conflict with vue-datatable
Vue.use(VeeValidate, config)

Vue.use(ScrollLoader)
Vue.use(VueScrollto)
Vue.use(VueMoment)
Vue.use(VModal, {
  dynamicDefaults: {
    clickToClose: false,
    height: 'auto',
    width: '300px'
  }
})
Vue.use(VueTour)
// intercepting requests
axios.defaults.showLoader = true
axios.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken) {
      config.headers.Authorization = 'Bearer ' + accessToken
    }
    if (config.method === 'get' && config.showLoader) {
      store.dispatch('loader/pending')
    }
    return config
  },
  function (error) {
    // Do something with request error
    if (error.config.method === 'get' && error.config.showLoader) {
      store.dispatch('loader/done')
    }
    return Promise.reject(error)
  }
)

// intercepting responses
axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    if (response.config.method === 'get' && response.config.showLoader) {
      store.dispatch('loader/done')
    }
    return response
  },
  function (error) {
    // Do something with response error
    if (error && error.response && error.response.status === 401) {
      Error401()
    }
    if (error && error.response && error.response.config.showLoader) {
      store.dispatch('loader/done')
    }
    return Promise.reject(error)
  }
)

const RefreshTokenInterval =
  process.env.VUE_APP_RefreshTokenIntervalInMinutes * 60 * 1000
function refreshToken () {
  if (store.state.auth.loggedIn) {
    AuthService.refreshToken().then(response => {
      if (response && response.data.success) {
        store.dispatch(
          'auth/refreshAccessToken',
          response.data.accessToken
        )
      } else {
        Error401()
      }
    })
  }
}
refreshToken()
setInterval(() => {
  refreshToken()
}, RefreshTokenInterval)

function Error401 () {
  if (router.currentRoute.fullPath !== '/auth/sso') {
    alert('Either session is expired or you are not authorized for the action. Please try login again.', 'warning')
    store.dispatch('auth/logout')
    router.push('/auth/sso-error')
  }
}

function getShopShortName () {
  // eslint-disable-next-line no-useless-escape
  var regex = /:\/\/([^\/]+)/
  var shopAlias = regex.exec(window.location.href)[1].split('.')[0]
  shopAlias = shopAlias !== 'www' ? shopAlias : ''
  return shopAlias
}

router.beforeEach((to, from, next) => {
  Vue.prototype.$Referrer = from
  next()
});
(async () => {
  const fallback = i18n.fallbackLocale || 'en'
  const current = i18n.locale || 'en'
  const fallbackMessages = await loadLocaleMessages(fallback)
  if (Object.keys(fallbackMessages).length) {
    i18n.setLocaleMessage(fallback, fallbackMessages)
  }
  if (current !== fallback) {
    const currentMessages = await loadLocaleMessages(current)
    if (Object.keys(currentMessages).length) {
      i18n.setLocaleMessage(current, currentMessages)
    }
  }

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})()
